'use strict';

var ChartFbcApplicabilityYAxisService = function ChartFbcApplicabilityYAxisService() {
  var emptySpacePartToHide = 0.3; //30%

  function createYConfigWithEmptySpace(values, range, height, yMin, yMax, barHeight) {
    var minRemoveEmptySpaceSize = range * emptySpacePartToHide;
    var valueRangesToRemove = [];
    var i;
    if (values.length > 1) {
      for (i = 0; i < values.length - 1; i++) {
        if (values[i + 1] - values[i] >= minRemoveEmptySpaceSize) {
          valueRangesToRemove.push({
            from: values[i],
            to: values[i + 1]
          });
        }
      }
    }
    if (valueRangesToRemove.length === 0) {
      //no empty spaces can be removed
      var barPartHeight = barHeight / (height - barHeight);
      return {
        domain: [yMin - barPartHeight * range, yMax],
        range: [height, 0]
      };
    }
    var visibleRanges = [{
      from: yMin
    }];
    for (var s = 0; s < valueRangesToRemove.length; s++) {
      var rangeToRemove = valueRangesToRemove[s];
      visibleRanges[s].to = rangeToRemove.from;
      visibleRanges.push({
        from: rangeToRemove.to
      });
    }
    visibleRanges[visibleRanges.length - 1].to = yMax;
    var rangesSize = 0;
    for (i = 0; i < visibleRanges.length; i++) {
      var el = visibleRanges[i];
      if (el.to === el.from) {
        if (i !== visibleRanges.length - 1) {
          el.to += range / 200;
        }
        if (i !== 0) {
          el.from -= range / 200;
        }
      }
      rangesSize += el.to - el.from;
    }
    if (rangesSize === 0) {
      rangesSize = 1;
    }
    var m = (height - 2 * 1.5 * barHeight - barHeight * 2 * (visibleRanges.length - 2)) / rangesSize;
    var element;
    for (i = visibleRanges.length - 2; i > 0; i--) {
      element = visibleRanges[i];
      element.from -= barHeight * 1.5 / m;
      element.to += barHeight * 0.5 / m;
    }
    visibleRanges[0].from -= barHeight / m;
    visibleRanges[0].to += 0.5 * barHeight / m;
    visibleRanges[visibleRanges.length - 1].from -= barHeight * 1.5 / m;
    var domain = [];
    var topChartPoint = height;
    var yRange = [];
    for (i = 0; i < visibleRanges.length; i++) {
      element = visibleRanges[i];
      domain.push(element.from, element.to);
      yRange.push(topChartPoint);
      topChartPoint -= (element.to - element.from) * m;
      yRange.push(topChartPoint);
    }
    return {
      domain: domain,
      range: yRange
    };
  }
  function isBarsInPile(values, barPartHeight, range) {
    var barRangeSize = barPartHeight * range;
    var result = false;
    for (var i = 0; i < values.length - 1; i++) {
      if (values[i] + barRangeSize > values[i + 1]) {
        result = true;
        break;
      }
    }
    return result;
  }
  function showTick(value, domain) {
    if (value < domain[0] || value > domain[domain.length - 1]) {
      return true;
    }
    for (var i = 1; i < domain.length; i += 2) {
      if (value <= domain[i] && value >= domain[i - 1]) {
        return true;
      }
    }
    return false;
  }
  function getYAxisTicksConfig(yScale, yNumberOfTicks) {
    var domain = yScale.domain();
    if (domain.length > 2) {
      var visibleRangeSize = 0;
      for (var i = 1; i < domain.length; i += 2) {
        visibleRangeSize += domain[i] - domain[i - 1];
      }
      var wholeRange = domain[domain.length - 1] - domain[0];
      var tiksQuantity = Math.round((yNumberOfTicks + 1) * wholeRange / visibleRangeSize);
      var data = yScale.ticks(tiksQuantity);
      var tickValues = [];
      for (var n = 0; n < data.length; n++) {
        var tickValue = data[n];
        if (showTick(tickValue, domain)) {
          tickValues.push(tickValue);
        }
      }
      return {
        yNumberOfTicks: tiksQuantity,
        tickValues: tickValues
      };
    } else {
      return {
        yNumberOfTicks: yNumberOfTicks,
        tickValues: null
      };
    }
  }
  return {
    createYConfigWithEmptySpace: createYConfigWithEmptySpace,
    isBarsInPile: isBarsInPile,
    getYAxisTicksConfig: getYAxisTicksConfig
  };
};
ChartFbcApplicabilityYAxisService.$inject = [];
module.exports = ChartFbcApplicabilityYAxisService;